module.exports = __webpack_public_path__ + "img/benefits_02.c39c4cce.jpeg";